import { set, flow, some, reduce } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchReservationForView,
  updateReservationStatus,
  unlinkReservation
} from '../../../sagas/routines';
import { clearReservationView } from '../../../actions/routes/view';

const initialState = {
  data: null,
  hasLinkedOrderItems: false,
  fetching: false,
  fetched: false,
  saving: false,
  saved: false
};

const fetchReservationViewHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response: data } }) => {
    const hasLinkedOrderItems = flow(
      reduce((allItems, each) => [...allItems, ...each.items], []),
      some('inventoryItemId')
    )(data.orders);
    return { ...state, data, hasLinkedOrderItems };
  },

  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const updateReservationStatusHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const unlinkReservationHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const clearReservationViewHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchReservationViewHandler(fetchReservationForView),
  ...updateReservationStatusHandler(updateReservationStatus),
  ...unlinkReservationHandler(unlinkReservation),
  ...clearReservationViewHandler(clearReservationView)
});
